<app-back-header-atom
  icon="arrow-left"
  [text]="'validate-shared-order.title' | translate"
  (navigationClick)="back()"
></app-back-header-atom>
